module.exports = "<div class=\"page\">\n    <div class=\"page-content container-fluid\" >\n        <flash-messages></flash-messages>\n        <router-outlet></router-outlet>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layouts/basic.template.html
// module id = ./src/app/layout/layouts/basic.template.html
// module chunks = main